<template>
  <div class="chart">
    <div class="chart__bars">
      <div
        v-for="(item, index) of results"
        :key="index"
        class="chart__container"
      >
        <div class="chart__label">{{ item.label }}</div>

        <div class="chart__result">
          <span
            :id="`chart__result-value-${index}`"
            class="chart__result-value"
          >
            {{ item.result }}
          </span>
          <div
            :id="`chart__result-bar-${index}`"
            class="chart__result-bar"
          ></div>
        </div>
      </div>

      <div class="chart__axis-legend">
        <span v-for="(item, index) of axisLegend" :key="index">{{ item }}</span>
      </div>
    </div>

    <div class="chart__legend">
      <div
        v-for="(item, index) of legend"
        :key="index"
        class="chart__legend-item"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Graph',
  props: {
    results: {
      type: Array,
      default() {
        return []
      },
    },

    axisLegend: {
      type: Array,
      default() {
        return [0, 3, 6, 9, 12]
      },
    },

    legend: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    axisLegend: function () {
      this.userDidChangeResults()
    },
    results: function () {
      this.userDidChangeResults()
    },
    legend: function () {
      this.userDidChangeResults()
    },
  },
  methods: {
    userDidChangeResults: async function () {
      const maxValue = this.axisLegend[this.axisLegend.length - 1]

      // we need a timeout to ensure that the elements are rendered in the dom
      await this.$nextTick()
      for (let i = 0; i < this.results.length; i++) {
        const barId = '#chart__result-bar-' + i
        const valueId = '#chart__result-value-' + i
        const result = this.results[i]

        // empty bar case
        if (result.result === 0) {
          this.$el.querySelector(valueId).classList.add('is-zero')
        }

        this.$el.querySelector(barId).style.width =
          (result.result * 100) / maxValue + '%'
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.chart {
}

.chart__bars {
  margin-bottom: 40px;
}

.chart__container {
  display: inline-flex;
  align-items: center;

  width: 100%;
  padding-left: 15px;
  border-bottom: 1px dotted var(--c-secondary-neutral-3);

  box-sizing: border-box;
}

.chart__label,
.chart__result {
  display: inline-flex;
  align-items: center;
}

.chart__label {
  font-size: 13px;
  line-height: 18px;
  color: var(--c-secondary-neutral-1);

  width: 35%;
  padding-right: 5px;
  word-break: break-all;
}

.chart__result {
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: var(--c-primary-neutral-1);
  position: relative;

  /* for some reason using 65% breaks the flow */
  width: 64%;
  height: 40px;
}

.chart__result-value {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translate3d(0, -50%, 0);

  color: var(--c-primary-neutral-3);

  &.is-zero {
    color: var(--c-primary-color-2);
  }
}

.chart__result-bar {
  height: 100%;

  background-color: var(--c-primary-color-2);
}

.chart__axis-legend {
  font-size: 13px;
  line-height: 1.35;
  color: var(--c-secondary-neutral-1);

  display: flex;
  justify-content: space-between;

  margin-top: 17px;
  /* manually adjusted value */
  margin-left: calc(35% + 11px);
}

.chart__legend-item {
  font-size: 11px;
  line-height: 1;
  color: var(--c-secondary-neutral-2);

  margin-bottom: 7px;
}

@media (--md) {
  .chart__legend-item {
    font-size: 12px;
    line-height: 1.1;
  }
}
</style>
